
import { Link } from "react-router-dom";
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { cn } from "@/lib/utils/cn";
import { IconX, IconSquidsLogo } from "@/components/ui/Icons";

interface GuestBannerProps {
  className?: string;
}

export function GuestBanner({ className }: GuestBannerProps) {
  const [dismissed, setDismissed] = useState(false);

  return (
    <AnimatePresence>
      {!dismissed && (
        <motion.div
          initial={{ opacity: 0, y: -12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -12, height: 0, marginBottom: 0 }}
          transition={{ duration: 0.3, ease: [0.16, 1, 0.3, 1] }}
          className={cn("mb-6", className)}
        >
          <div className="relative rounded-2xl border border-brand/30 bg-gradient-to-r from-brand-muted to-accent/10 p-4 overflow-hidden">
            {/* Background decoration */}
            <div className="absolute right-0 top-0 bottom-0 w-32 opacity-10 pointer-events-none">
              <IconSquidsLogo className="absolute right-4 top-1/2 -translate-y-1/2 w-20 h-20 text-brand" />
            </div>

            <div className="flex items-center gap-4 pr-8">
              <div className="flex-1 min-w-0">
                <p className="text-sm font-semibold text-foreground">
                  Join the conversation on Squids
                </p>
                <p className="text-xs text-text-muted mt-0.5">
                  Vote, comment, share, and follow topics you love.
                </p>
              </div>

              <div className="flex items-center gap-2 flex-shrink-0">
                <Link to="/auth/login"
                  className="btn-secondary btn-sm"
                >
                  Sign in
                </Link>
                <Link to="/auth/register"
                  className="btn-primary btn-sm"
                >
                  Join free
                </Link>
              </div>
            </div>

            {/* Dismiss */}
            <button
              onClick={() => setDismissed(true)}
              className="absolute top-3 right-3 w-6 h-6 flex items-center justify-center rounded-md text-text-subtle hover:text-foreground hover:bg-muted/50 transition-colors"
              aria-label="Dismiss banner"
            >
              <IconX className="w-3.5 h-3.5" />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
